<template>
    <div class="flex items-center justify-center gap-2">
        <custom-tooltip v-for="action in actions" :key="action.key">
            <button
                type="button"
                class="flex h-11 w-11 items-center justify-center rounded-lg border shadow-sm transition disabled:cursor-not-allowed disabled:opacity-50"
                :class="
                    action.colorClass ||
                    'border-theme-border bg-brand-blue text-white hover:bg-brand-purple'
                "
                :disabled="action.disabled"
                @click="action.onClick"
            >
                <component :is="action.icon" class="h-5 w-5" />
            </button>
            <template #tooltip>
                {{
                    action.disabled && action.disabledReason
                        ? action.disabledReason
                        : action.label
                }}
            </template>
        </custom-tooltip>
    </div>
</template>

<script>
import CustomTooltip from "@/components/utils/CustomTooltip.vue";

export default {
    name: "CatalogEditorQuickActionsToolbar",
    components: { CustomTooltip },
    props: {
        actions: { type: Array, required: true }
    }
};
</script>
